import React from 'react';
import { CcLoader } from '@utp/components-react';
import { Wrapper, InputText } from './styled';
import { Icon } from '../../components';

interface EnterSearchProps {
  disabled?: boolean;
  error?: string;
  isLoadingData: boolean;
  onChange: (e: any) => void;
  value: string;
  setSearchText: (e: any) => void;
  tabTitle: any;
}
const EnterSearch = ({
  disabled,
  error,
  isLoadingData,
  onChange,
  value,
  setSearchText,
  tabTitle
}: EnterSearchProps) => (
  <Wrapper
    className={`${value ? 'filled' : ''} ${error ? 'error' : ''} ${
      disabled ? 'disabled' : ''
    }`}
  >
    <InputText
      data-testid="cmp-enterSearch"
      disabled={disabled}
      type="text"
      id="enterSearch"
      className="enterSearch"
      placeholder={`Busca tus ${tabTitle.toLowerCase()}`}
      value={value}
      onChange={(e) => {
        setSearchText(e.target.value);
      }}
      onKeyDown={onChange}
      autoComplete="off"
    />
    {!value ? (
      <button
        data-testid="cmp-inputSearch-btn"
        type="button"
        className=""
        disabled={disabled}
        onClick={() => {
          if (value) {
            onChange('');
            const input = document.getElementById('inputSearch');
            input?.focus();
          }
        }}
      >
        {isLoadingData && <CcLoader size={20} className="searchLoader" />}
        {!isLoadingData && <Icon name={'search'} size={20} color="#5B36F2" />}
      </button>
    ) : (
      <button
        data-testid="cmp-inputSearch-btn"
        type="button"
        className=""
        disabled={disabled}
        onClick={() => {
          setSearchText('');
        }}
      >
        {isLoadingData && <CcLoader size={20} className="searchLoader" />}
        {!isLoadingData && <Icon name={'x'} size={20} color="var(--primary)" />}
      </button>
    )}
  </Wrapper>
);

EnterSearch.defaultProps = {
  disabled: false,
  error: ''
};

export default EnterSearch;
